import api from ".";
import { getToken } from "../Auth/Token";

export const getCostingSettings = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/costing-settings", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data; 
  } catch (error) {
    console.error("Get Costing Settings API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateFxRates = async (fxRates) => {
  try {
    const token = getToken();

    if (!Array.isArray(fxRates)) {
      throw new Error("FX rates array is required");
    }

    const res = await api.post(
      "/api/costing-settings/fx-rates",
      { fxRates },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Update FX Rates API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateRoyaltyRules = async (royaltyRules) => {
  try {
    const token = getToken();

    if (!Array.isArray(royaltyRules)) {
      throw new Error("Royalty rules array is required");
    }

    const res = await api.post(
      "/api/costing-settings/royalty-rules",
      { royaltyRules },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Update Royalty Rules API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateCategoryRules = async (categoryRules) => {
  try {
    const token = getToken();

    if (!Array.isArray(categoryRules)) {
      throw new Error("Category rules array is required");
    }

    const res = await api.post(
      "/api/costing-settings/category-rules",
      { categoryRules },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Update Category Rules API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateGlobalAssumptions = async (globalAssumptions) => {
  try {
    const token = getToken();

    if (!globalAssumptions || typeof globalAssumptions !== "object") {
      throw new Error("Global assumptions object is required");
    }

    const res = await api.post(
      "/api/costing-settings/global-assumptions",
      { globalAssumptions },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Update Global Assumptions API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateSccLevels = async (sccLevels) => {
  try {
    const token = getToken();

    if (!Array.isArray(sccLevels)) {
      throw new Error("SCC levels array is required");
    }

    const res = await api.post(
      "/api/costing-settings/scc-levels",
      { sccLevels },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Update SCC Levels API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateSegmentMappings = async (segmentCategoryMappings) => {
  try {
    const token = getToken();

    const res = await api.post(
      "/api/costing-settings/segment-mappings",
      { segmentCategoryMappings },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Update Segment Mappings API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const getThroughputOverhead = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/costing-settings/throughput-overhead", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Throughput Overhead API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateThroughputOverhead = async (throughputOverhead) => {
  try {
    const token = getToken();

    if (!Array.isArray(throughputOverhead)) {
      throw new Error("Throughput overhead array is required");
    }

    const res = await api.post(
      "/api/costing-settings/throughput-overhead",
      { throughputOverhead },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Update Throughput Overhead API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updatePackagingBOM = async (packagingBOM) => {
  try {
    const token = getToken();

    if (!packagingBOM || typeof packagingBOM !== "object") {
      throw new Error("packagingBOM object is required");
    }

    const res = await api.post(
      "/api/costing-settings/packaging",
      { packagingBOM },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Update Packaging BOM API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const getAllPackagingVariants = async (options = {}) => {
  try {
    const { params, timeoutMs } = options;
    const res = await api.get("/api/packaging-variants", {
      params,
      timeout: timeoutMs,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return res.data;
  } catch (error) {
    console.error("Get All Packaging Variants Error:", error);
    throw error;
  }
};

export const createPackagingVariant = async (data) => {
  try {
    const res = await api.post("/api/packaging-variants", data, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    return res.data;
  } catch (error) {
    console.error("Create Packaging Variant Error:", error);
    throw error;
  }
};

export const updatePackagingVariant = async (id, data) => {
  try {
    const res = await api.put(`/api/packaging-variants/${id}`, data, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    return res.data;
  } catch (error) {
    console.error("Update Packaging Variant Error:", error);
    throw error;
  }
};

export const deletePackagingVariant = async (id) => {
  try {
    const res = await api.delete(`/api/packaging-variants/${id}`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    return res.data;
  } catch (error) {
    console.error("Delete Packaging Variant Error:", error);
    throw error;
  }
};

export const getAllSpiceBlends = async () => {
  try {
    const res = await api.get("/api/products/getSpicesBlends", {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    });
    return res.data;
  } catch (error) {
    console.error("Get All Spice Blends Error:", error);
    throw error;
  }
};

// ─── Channel Rules ────────────────────────────────────────────────────────────

export const getChannelRules = async () => {
  try {
    const res = await api.get("/api/channel-rules/fetch", {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Channel Rules API Error:", {
      status: error.response?.status,
      data:   error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const createChannelRule = async (ruleData) => {
  try {
    if (!ruleData || typeof ruleData !== "object") {
      throw new Error("Channel rule data object is required");
    }

    const res = await api.post("/api/channel-rules/create", ruleData, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create Channel Rule API Error:", {
      status: error.response?.status,
      data:   error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateChannelRule = async (id, ruleData) => {
  try {
    if (!id) throw new Error("Channel rule ID is required");
    if (!ruleData || typeof ruleData !== "object") {
      throw new Error("Channel rule data object is required");
    }

    const res = await api.put(`/api/channel-rules/${id}`, ruleData, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Update Channel Rule API Error:", {
      status: error.response?.status,
      data:   error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const deleteChannelRule = async (id) => {
  try {
    if (!id) throw new Error("Channel rule ID is required");

    const res = await api.delete(`/api/channel-rules/${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Delete Channel Rule API Error:", {
      status: error.response?.status,
      data:   error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
export const fetchBulkRules = async () => {
  try {
    const res = await api.get("/api/bulk-rules/fetch", {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data.data ?? [];
  } catch (error) {
    console.error("Fetch Bulk Rules Error:", error);
    throw error;
  }
};
 
// ─── Create a new bulk rule ───────────────────────────────────────────────
export const createBulkRule = async (payload) => {
  try {
    const res = await api.post("/api/bulk-rules/create", payload, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create Bulk Rule Error:", error);
    throw error;
  }
};
 
// ─── Update bulk rule by ID ───────────────────────────────────────────────
export const updateBulkRule = async (id, payload) => {
  try {
    const res = await api.put(`/api/bulk-rules/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Update Bulk Rule Error:", error);
    throw error;
  }
};
 
// ─── Delete bulk rule by ID ───────────────────────────────────────────────
export const deleteBulkRule = async (id) => {
  try {
    const res = await api.delete(`/api/bulk-rules/${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Delete Bulk Rule Error:", error);
    throw error;
  }
};

export const updatePrivateLabelMarginTiers = async (privateLabelMarginTiers) => {
  try {
    const token = getToken();

    if (!Array.isArray(privateLabelMarginTiers)) {
      throw new Error("Private Label margin tiers array is required");
    }

    const res = await api.post(
      "/api/costing-settings/private-label-margin-tiers",
      { privateLabelMarginTiers },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Update Private Label Margin Tiers API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updatePrivateLabelCustomerMappings = async (privateLabelCustomerMappings) => {
  try {
    const token = getToken();

    if (!Array.isArray(privateLabelCustomerMappings)) {
      throw new Error("Private Label customer mappings array is required");
    }

    const res = await api.post(
      "/api/costing-settings/private-label-customer-mappings",
      { privateLabelCustomerMappings },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Update Private Label Customer Mappings API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const syncErpagCustomersToMappings = async () => {
  try {
    const token = getToken();
    const res = await api.post(
      "/api/costing-settings/sync-erpag-customers",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Sync ERPAG Customers to Mappings API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const getErpagPlCategories = async () => {
  try {
    const token = getToken();
    const res = await api.get(
      "/api/costing-settings/erpag-pl-categories",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Get ERPAG PL Categories API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
